import { onMounted } from "vue";
import { useAccountStore } from "~/store/account";
import { AccoutLocalStorage } from "~/store/account";

const CHECK_TOKEN_INTERVAL = 5000;
export function useTokenReflesh() {
  // onMounted(() => {
  const accountStore = useAccountStore();
  setInterval(() => {
    const ACCOUNT_INFO = AccoutLocalStorage;
    const expiresTime = ACCOUNT_INFO.value?.expires_time;
    const currentTime = new Date().getTime();
    // console.log("expiresTime - currentTime:", expiresTime - currentTime);
    if (!!expiresTime && expiresTime - currentTime < 0) {
      accountStore.doRefreshToken();
    }
  }, CHECK_TOKEN_INTERVAL);
  // });
}
